export default {"src":"/pro/_next/static/media/elixir-logo.cc1af1e4.svg","height":198,"width":731,"blurWidth":0,"blurHeight":0};